import type { Category } from "@/types/video";

export const categories: Category[] = [
  {
    slug: "night",
    name: "夜色浪漫",
    icon: "ri-moon-clear-line",
    summary: "午夜灯影下的温柔叙事",
    description:
      "夜晚是这类影像最好的布景。夜色浪漫频道收录以城市夜景、雨巷与霓虹为背景的短片，强调光影层次与情绪铺陈，适合喜欢沉浸式夜色氛围的观众。",
  },
  {
    slug: "city",
    name: "都市情缘",
    icon: "ri-building-4-line",
    summary: "写字楼与天台的现代情感",
    description:
      "从玻璃幕墙到顶楼泳池，都市情缘频道把镜头对准现代城市空间，讲述发生在通勤、加班与偶遇之间的情感片段，节奏明快、画面干净。",
  },
  {
    slug: "drama",
    name: "情感剧情",
    icon: "ri-film-line",
    summary: "有起承转合的情绪故事",
    description:
      "情感剧情频道偏向完整叙事，每一部都有清晰的人物关系与情绪转折，适合愿意安静看完一整段故事的观众。",
  },
  {
    slug: "visual",
    name: "光影写真",
    icon: "ri-camera-lens-line",
    summary: "以构图与质感为核心的视觉作品",
    description:
      "光影写真频道弱化叙事，把注意力交给色彩、材质与镜头语言。红丝绒、琥珀光、烛火与丝绸，是这里最常见的画面元素。",
  },
  {
    slug: "classic",
    name: "经典回顾",
    icon: "ri-history-line",
    summary: "录像带时代的质感复刻",
    description:
      "经典回顾频道整理上世纪九十年代以来的影像风格作品，保留胶片颗粒与模拟信号的粗糙质感，是怀旧观众的第一站。",
  },
  {
    slug: "behind",
    name: "幕后访谈",
    icon: "ri-mic-line",
    summary: "灯光、镜头与创作者的对谈",
    description:
      "幕后访谈频道走进片场，与灯光师、导演和摄影指导聊聊一部影像作品是如何被制造出来的，适合对制作流程感兴趣的观众。",
  },
];